module.exports = __webpack_public_path__ + "img/icon-scene-5.6145fd98.png";